// 261010 UI1b — nhãn đáy từng khung storyboard kiểu Sky/TopView: `0s–5s | long shot | 24mm | dolly back` + thoại hoặc "No dialogue".
// Chỉ ĐỌC từ `frames` đã có (không gen / không sửa từng khung — gen lại vẫn cả tấm). mm SUY từ cỡ cảnh (shotCameraUtils).
import React from 'react';
import type { FilmShot, StoryboardFrame } from '../../types/film';
import { storyboardCaptionOf } from './shotCameraUtils';

const StoryboardCaptions: React.FC<{ frames: StoryboardFrame[] | null | undefined; shots?: FilmShot[] | null }> = ({ frames, shots }) => {
  if (!frames || frames.length === 0) return null;
  const sorted = [...frames].sort((a, b) => a.frameNo - b.frameNo);
  return (
    <ol className="wf-sbcap" aria-label="Nhãn từng khung storyboard" data-testid="wf-sb-captions">
      {sorted.map((f) => {
        const c = storyboardCaptionOf(f, shots);
        return (
          <li key={f.frameNo}>
            <span className="no">{f.frameNo}</span>
            <span className="cap mono" title={c.label}>{c.label}</span>
            <span className={`dlg${c.dialogue === 'No dialogue' ? ' none' : ''}`} title={c.dialogue}>{c.dialogue}</span>
          </li>
        );
      })}
    </ol>
  );
};

export default StoryboardCaptions;
